import { graphql, useStaticQuery } from 'gatsby';

export const useAboutUsImages = () => {
    const data = useStaticQuery(graphql`
        query aboutUs {
            images: allFile(
                filter: { relativeDirectory: { eq: "aboutUs" } }
                sort: { order: ASC, fields: name }
            ) {
                nodes {
                    id
                    name
                    childImageSharp {
                        fluid(maxHeight: 800, quality: 100) {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    `);
    return data;
};
